<template>
  <div class="admin-v2-countdown">
    <span class="admin-v2-countdown__title">Chuyển sang Web Version 2 sau</span>

    <span class="admin-v2-countdown__timer">
      <span
          v-for="item in countdownItems"
          :key="item.key"
          class="admin-v2-countdown__time-item"
      >
        <span class="admin-v2-countdown__number">{{ item.value }}</span>
        <span class="admin-v2-countdown__unit">{{ item.label }}</span>
      </span>
    </span>

    <span class="admin-v2-countdown__line" aria-hidden="true"></span>
    <button
        type="button"
        class="admin-v2-countdown__cta"
        @click="openAdminV2"
    >Trải nghiệm ngay</button>
  </div>
</template>

<script>
export default {
  name: "AdminV2CountdownBanner",
  props: {
    actionUrl: {
      type: String,
      required: true
    },
    targetDate: {
      type: String,
      default: "2026-10-10T00:00:00+07:00"
    }
  },
  data() {
    return {
      remainingTime: 0,
      countdownTimer: null
    };
  },
  computed: {
    countdownItems() {
      const seconds = Math.max(0, Math.floor(this.remainingTime / 1000));
      const days = Math.floor(seconds / 86400);
      const hours = Math.floor((seconds % 86400) / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;

      return [
        { key: "days", value: this.padTime(days), label: "ngày" },
        { key: "hours", value: this.padTime(hours), label: "giờ" },
        { key: "minutes", value: this.padTime(minutes), label: "phút" },
        { key: "seconds", value: this.padTime(secs), label: "giây" }
      ];
    }
  },
  mounted() {
    this.updateCountdown();
    this.countdownTimer = setInterval(this.updateCountdown, 1000);
  },
  beforeDestroy() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
  },
  methods: {
    openAdminV2() {
      window.open(this.actionUrl, "_blank", "noopener,noreferrer");
    },
    updateCountdown() {
      this.remainingTime = Math.max(0, new Date(this.targetDate).getTime() - Date.now());
    },
    padTime(value) {
      return value < 10 ? `0${value}` : String(value);
    }
  }
};
</script>

<style scoped>
.admin-v2-countdown {
  display: flex;
  align-items: center;
  min-width: 0;
  width: 100%;
  min-height: 64px;
  padding: 8px 8px 8px 18px;
  overflow: hidden;
  color: #ffffff !important;
  background: #6f42c1;
  border-radius: 4px;
  box-shadow: inset 0 -1px 0 rgba(255, 255, 255, 0.12);
  text-decoration: none !important;
}

.admin-v2-countdown__title {
  flex: 0 0 auto;
  margin-right: 18px;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
}

.admin-v2-countdown__timer {
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
  gap: 8px;
}

.admin-v2-countdown__time-item {
  display: inline-flex;
  align-items: baseline;
  gap: 3px;
  padding: 4px 6px;
  background: rgba(255, 255, 255, 0.12);
  border-radius: 2px;
  white-space: nowrap;
}

.admin-v2-countdown__number {
  min-width: 22px;
  font-size: 14px;
  font-weight: 800;
  line-height: 1;
  text-align: center;
}

.admin-v2-countdown__unit {
  font-size: 8px;
  font-weight: 600;
  line-height: 1;
  opacity: 0.75;
}

.admin-v2-countdown__line {
  flex: 1 1 auto;
  min-width: 60px;
  height: 1px;
  margin: 0 20px;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.45), rgba(255, 255, 255, 0));
}

.admin-v2-countdown__cta {
  font-family: "Roboto", sans-serif;
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 118px;
  height: 48px;
  padding: 0 16px;
  border: 0;
  cursor: pointer;
  border-radius: 2px;
  background: #f4effb;
  color: #512b91;
  font-size: 13px;
  font-weight: 800;
  line-height: 1;
  white-space: nowrap;
  transition: background-color 0.2s ease, box-shadow 0.2s ease;
}

.admin-v2-countdown__cta:hover,
.admin-v2-countdown__cta:focus-visible {
  background: #e7dcf7;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.4);
}

@media (max-width: 1199.98px) {
  .admin-v2-countdown__line {
    min-width: 0;
    margin: 0 12px;
  }
}

@media (max-width: 1199.98px) {
  .admin-v2-countdown {
    flex-wrap: wrap;
    gap: 10px;
    padding: 12px;
  }

  .admin-v2-countdown__title {
    flex-basis: 100%;
    margin-right: 0;
  }

  .admin-v2-countdown__line {
    display: none;
  }

  .admin-v2-countdown__cta {
    min-width: 0;
    height: 32px;
    margin-left: auto;
    padding: 0 10px;
  }

  .admin-v2-countdown__timer {
    gap: 4px;
  }

  .admin-v2-countdown__time-item {
    padding: 4px;
  }

  .admin-v2-countdown__number {
    min-width: 18px;
    font-size: 12px;
  }
}
</style>